export interface PortForward {
  id: string | undefined
  name: string | undefined,
  protocol: string | undefined,
  externalPort: string | undefined,
  internalPort: string | undefined,
  internalIp: string | undefined,
  enabled: boolean | undefined
}
